import { useQuery } from '@tanstack/react-query';
import { Contract } from 'tronweb';

import { useTronWallet } from '../provider';

export const useContract = <TContract extends Contract>(l1ContractAddress?: string) => {
  const { tronWeb, address } = useTronWallet();

  const { data } = useQuery({
    queryKey: ['tron-contract', l1ContractAddress, address],
    queryFn: async (): Promise<TContract | null> => {
      if (!tronWeb || !l1ContractAddress) {
        throw new Error('tronWeb and l1ContractAddress are required');
      }
      try {
        return (await tronWeb.contract().at(l1ContractAddress)) as TContract;
      } catch (error) {
        console.error(error);
        return null;
      }
    },
    enabled: !!tronWeb && !!l1ContractAddress,
    staleTime: Number.POSITIVE_INFINITY,
  });

  return (data ?? null) as TContract | null;
};
